import { call, put, select, takeLatest } from 'redux-saga/effects';
import { SendApiRequest } from 'src/api';
import { apiRoutes } from 'src/api/routes';

import {
    fetchCertificates,
    certificatesFetched,
    certificatesFetchRequestFailed,
    fetchCertificateTypes,
    certificateTypesFetched,
    certificateTypesFetchRequestFailed,
} from '../certificates';
import { getSelectedProvince } from '../user-settings';

function* fetchCertificatesEffect({ payload }) {
    // Select the province from the Redux store
    const selectedProvince = yield select(getSelectedProvince);
    try {
        const response = yield call(SendApiRequest, {
            url: apiRoutes.certificates,
            method: 'GET',
            queryParams: {
                ...payload,
                ...(selectedProvince !== 'All' && {
                    province: selectedProvince,
                }),
            },
        });

        yield put(
            certificatesFetched({
                results: response.results,
                totalRecords: response.totalRecords,
            }),
        );
    } catch (e) {
        yield put(certificatesFetchRequestFailed());
    }
}

// NEW: Fetch certificate types effect
function* fetchCertificateTypesEffect() {
    try {
        const response = yield call(SendApiRequest, {
            url: apiRoutes.certificateQueue.getCertificateTypes,
            method: 'GET',
        });

        // CRITICAL: Extract the types array from response
        const typesArray = response?.types || [];
        yield put(certificateTypesFetched(typesArray));
    } catch (e) {
        console.error('Error fetching certificate types:', e);
        yield put(certificateTypesFetchRequestFailed());
    }
}

// Watcher Saga: listens for the fetch actions
export const certificatesSagas = [
    takeLatest(fetchCertificates.type, fetchCertificatesEffect),
    takeLatest(fetchCertificateTypes.type, fetchCertificateTypesEffect),
];
